// Listing-expiration reminders stay hidden until 30 days before the listing expires.
// The reminder's own offset tells us the expiration date: expires = dueDate - offset.
const EXPIRATION_OFFSETS = [
  [/expir(es|ing) in 30 days/i, -30], [/expir(es|ing) in 15 days/i, -15],
  [/expir(es|ing) in 7 days/i, -7], [/expires tomorrow/i, -1],
];
const localToday = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`; };
const shift = (iso, days) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + days); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
export const isHiddenExpirationTask = (task, today = localToday()) => {
  const name = String(task?.name || task?.title || '');
  const hit = EXPIRATION_OFFSETS.find(([re]) => re.test(name));
  const due = String(task?.dueDate || '').slice(0, 10);
  if (!hit || !/^\d{4}-\d{2}-\d{2}$/.test(due)) return false;
  const expires = shift(due, -hit[1]);
  return today < shift(expires, -30);
};
// Post-closing tasks appear only once the deal is marked Closed (they are released with closedRelease: true).
export const CLOSED_ONLY_TASKS = /update mls status to closed|just sold social media post/i;
export const isHiddenUntilClosed = (task) => CLOSED_ONLY_TASKS.test(String(task?.name || task?.title || ''))
  && !task?.closedRelease && task?.status !== 'completed' && task?.status !== 'na';
export const visibleTasks = (list, today) => (list || []).filter((t) => !isHiddenExpirationTask(t, today) && !isHiddenUntilClosed(t));
